const boldRegex = /<strong>(.*?)<\/strong>/g

const extractBoldText = text =>
  (text || '').replaceAll('\n', '<br>').match(boldRegex)

export default extractBoldText
